<div class="property-details" [class.luxury]="listing.isLuxury && isListingDetails" [class.commercial]="listing.isCommercial">
  <ng-container *ngIf="!listing.isCommercial">
    <span class="detail">
      <ng-container
        *ngIf="listing.bedsBR && listing.bedsBRPlus ; then bedsDisplay1; else bedsDisplay2">
      </ng-container>
      
      <ng-template #bedsDisplay1>
        <span class="bold">{{listing.bedsBR}}</span>
        <span class="plus"> + </span>
        <span class="bold">{{listing.bedsBRPlus}}</span>
        <span class="classifier" translate="property-details.beds"></span>
      </ng-template>

      <ng-template #bedsDisplay2>
          <span class="bold">{{listing.beds ? (listing.beds | number:'1.0-2') : ('na' | translate)}}</span>
          <span class="classifier" translate="property-details.beds"></span>
      </ng-template>
    </span>

    <ng-container
      *ngIf="isListingDetails; then detailDisplay; else searchDisplay">
    </ng-container>

    <ng-template #detailDisplay>
      <ng-container
        *ngIf="(listing.halfBaths && listing.fullBaths) ; then bathsDisplay1; else bathsDisplay2">
      </ng-container>
  
      <ng-template #bathsDisplay1>
        <span class="divider">|</span>
        <span class="detail">
          <span class="bold">{{listing.fullBaths}}</span>
          <span class="classifier" translate="property-details.full-baths"></span>
        </span>
        <span class="divider">|</span>
        <span class="detail">
          <span class="bold">{{listing.halfBaths}}</span>
          <span class="classifier" translate="property-details.half-baths"></span>
        </span>
      </ng-template>
  
      <ng-template #bathsDisplay2>
        <span class="divider">|</span>
        <span class="detail">
          <span class="bold">{{listing.baths ? (listing.baths | number: '1.0') : ('na' | translate)}}</span>
          <span class="classifier" translate="property-details.baths"></span>
        </span>
      </ng-template>
    </ng-template>

    <ng-template #searchDisplay>
      <ng-container
        *ngIf="(listing.halfBaths && listing.fullBaths) ; then bathsDisplay1; else bathsDisplay2">
      </ng-container>
  
      <ng-template #bathsDisplay1>
        <span class="divider">|</span>
        <span class="detail">
          <span class="bold">{{listing.fullBaths}}</span>
          <span class="plus"> + </span>
          <span class="bold">{{listing.halfBaths}}</span>
          <span class="classifier" translate="property-details.baths"></span>
        </span>
      </ng-template>
  
      <ng-template #bathsDisplay2>
        <span class="divider">|</span>
        <span class="detail">
          <span class="bold">{{listing.totalBaths ? (listing.totalBaths | number:'1.0-2') : ('na' | translate)}}</span>
          <span class="classifier" translate="property-details.baths"></span>
        </span>
      </ng-template>      
    </ng-template>

    <span class="divider">|</span>
    <span class="detail">
      <span class="bold">{{listing.sqFtSearch > 0 ? listing.sqFtSearch : ('na' | translate)}} </span>
      <span class="classifier" translate="property-details.sqft"></span>
    </span>
  </ng-container>
  <ng-container *ngIf="listing.isCommercial">
    <ng-container *ngIf="!listing.isFarm">
      <span>
        <span class="detail">
          <span class="bold">{{listing.sqFtSearch > 0 ? listing.sqFtSearch : ('na' | translate)}} </span>
          <span class="classifier" translate="property-details.sqft"></span>
        </span>
      </span>
    </ng-container>
    <ng-container *ngIf="listing.isFarm">
      <span class="detail">
        <span class="bold property-details__acreage">{{listing.lotSizeSearch > 0 ? listing.lotSizeSearch : ('na' | translate)}}</span>
        <span class="classifier" translate="property-details.acreage"></span>
      </span>
    </ng-container>
    <ng-container *ngIf="listing.primaryBusinessType">
      <span class="detail">
        <span class="divider">|</span>
        <span class="classifier">{{listing.primaryBusinessType}}</span>
      </span>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="listing.isCondo; else townhouseTemplte">
    <span class="divider">|</span>
    <span class="detail">
      <span class="classifier" translate="property-details.condo"></span>
    </span>
  </ng-container>
  <ng-template #townhouseTemplte>
    <ng-container *ngIf="listing.isTownhouse">
      <span class="divider">|</span>
      <span class="detail">
        <span class="classifier" translate="property-details.townhouse"></span>
      </span>
    </ng-container>
  </ng-template>
  <ng-container *ngIf="listing.isHouse">
    <span class="divider">|</span>
    <span class="detail">
      <span class="classifier" translate="property-details.house"></span>
    </span>
  </ng-container>
</div>
